import React from 'react';
import { Container, Flex, Text } from '@chakra-ui/react';
import { PageHeader, TimeIndicator } from 'shared-components';

import BackButton from '../../atoms/BackButton';
import PrevNextButtons from '../../atoms/PrevNextButtons';
import SectionSummary, { SectionStatus } from '../../atoms/section-summary';

interface IProps {
  children: React.ReactNode;
  section1?: SectionStatus;
  section2?: SectionStatus;
  section3?: SectionStatus;
  section4?: SectionStatus;
  pageHeader?: string;
  minsToComplete?: number;
  hideProgress?: boolean;
  nextLabel?: string;
  onNext?: () => void;
  onPrevious?: () => void;
  onBackToTaskList?: () => void;
}

const SectionStartPage: React.FC<IProps> = props => {
  const {
    children,
    section1,
    section2,
    section3,
    section4,
    pageHeader,
    minsToComplete,
    hideProgress,
    nextLabel,
    onNext,
    onPrevious,
    onBackToTaskList
  } = props;

  return (
    <>
      {!hideProgress && (
        <SectionSummary section1={section1!} section2={section2!} section3={section3!} section4={section4!} />
      )}

      <Container my={6}>
        {onBackToTaskList ? <BackButton onBackToTaskList={onBackToTaskList} /> : null}

        <PageHeader>{pageHeader}</PageHeader>

        {minsToComplete ? (
          <Flex alignItems="center" my={8} gap={6} maxWidth="24rem" mx="auto">
            <TimeIndicator value={minsToComplete * 1.6} label={`${minsToComplete} min`} />

            <Text mb={0} color="muted">
              This section will take around{' '}
              <b>
                {minsToComplete} minute{minsToComplete > 1 && 's'}
              </b>{' '}
              to complete.
            </Text>
          </Flex>
        ) : null}

        {children}

        <PrevNextButtons onNext={onNext} onPrevious={onPrevious} complete={true} nextLabel={nextLabel} />
      </Container>
    </>
  );
};

export default SectionStartPage;
